import axios from 'axios';
import storeMain from '@/store';
// import router from '@/router';

export const moduleCasino = {
  state: {
    freespins: [],
    rounds: {},
    detailRound: {},
    transactions: [],
    lobbies: [],
  },
  mutations: {
    setStatusCodeFantasy(state, payload){
      storeMain.commit('setStatusCode', payload);
    },
    setNotificationFantasy(state, message){
      storeMain.commit('setNotification', message);
    },
    getFreespins(state, list){
      state.freespins = list;
    },
    getRounds(state, list){
      state.rounds = list;
    },
    detailRound(state, detail){
      state.detailRound = detail;
    },
    getTransactions(state,list){
      state.transactions = list;
    },
    getLobbies(state,list){
      state.lobbies = list;
    },
  },
  actions: {

    async getFreespins({ commit, rootState }){
      const config = {
        headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      console.log('llamando a get freespins')
      commit('setWarningTime');
      axios
          .get(`${process.env.VUE_APP_SERVER}/backoffice/casino/freespins/list`, config)
          .then((res) => {
            commit('getFreespins', res.data);
          })
          .catch((error) => {
            console.log(error);
          });
    },

    async createFreespins({ commit, rootState }, freespinsData) {
      const config = {
        headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      commit('setStatusCodeFantasy',  {key: 'createFreespins', state:'', msg:'', loading: true});
      commit('setWarningTime');
      console.log(freespinsData.data)
      axios
          .post(`${process.env.VUE_APP_SERVER}/backoffice/casino/freespins/create`,freespinsData.data, config)
          .then((res) => {
            commit('setStatusCodeFantasy', {key: 'createFreespins', state: res.status, msg:res.statusText, loading: false});
            commit('setNotificationFantasy', 'Succesfully created freespins');
          })
          .catch((error) => {
            commit('setStatusCodeFantasy', {key: 'createFreespins', state: error.response.status, msg: error.response.statusText, loading: false});
            console.log(error);
          });
    },

    async toggleFreespins({commit, rootState}, freespinsData) {
      const config = {
        headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      console.log('actualizando el estado de freespins')
      commit('setStatusCodeFantasy',  {key: 'toggleFreespins', state:'', msg:'', loading: true});
      commit('setWarningTime');
      axios
          .post(`${process.env.VUE_APP_SERVER}/backoffice/casino/freespins/${freespinsData}/toggle`, {}, config)
          .then((res) => {
            commit('setStatusCodeFantasy',  {key: 'toggleFreespins', state: res.status, msg:res.statusText, loading: false});
          })
          .catch((error) => {
            commit('setStatusCodeFantasy',  {key: 'toggleFreespins', state: error.response.status, msg: error.response.statusText, loading: false});
          });
    },

    // async editFreespins({commit,rootState}, freespinsData) {
    //   const config = {
    //       headers: {Authorization: `bearer ${rootState.login.token}`},
    //   };
    //   console.log('editando freespins')
    //   commit('setStatusCodeFantasy',  {key: 'editFreespins', state:'', msg:'', loading: true});
    //   commit('setWarningTime');
    //   axios
    //       .post(`${process.env.VUE_APP_SERVER}/backoffice/casino/freespins/${freespinsData._id}/edit`,freespinsData.data, config)
    //       .then((res) => {
    //         commit('setStatusCodeFantasy',  {key: 'editFreespins', state: res.status, msg:res.statusText, loading: false});
    //         commit('setNotificationFantasy', 'Succesfully edited Freespins');
    //       })
    //       .catch((error) => {
    //         commit('setStatusCodeFantasy',  {key: 'editFreespins', state: error.response.status, msg: error.response.statusText, loading: false});
    //         commit('setNotificationFantasy', `Freespins can't be edited by ${error.response.statusText}`);
    //         console.log(error);
    //       });
    // },

    async getRounds({commit, rootState}, data) {
      const config = {
          headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      commit('setWarningTime');

      let offset = data.offset;
      let limit = data.limit;
      let id = data.id;
      let bookmaker = data.operator;
      let provider = data.provider;
      let game = data.game;
      let user = data.user;
      let start = data.start;
      let end = data.end;

      let params = `offset=${offset}&limit=${limit}&id=${id}&bookmaker=${bookmaker}&provider=${provider}&game=${game}&user=${user}&start=${start}&end=${end}`;

      axios
          .get(`${process.env.VUE_APP_SERVER}/backoffice/round/list?${params}`, config)
          .then((res) => {
            commit('getRounds', res.data);
          })
          .catch((error) => {
            console.log(error);
          });
    },

    async toggleRound({commit, rootState}, roundId) {
      const config = {
        headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      commit('setStatusCodeFantasy',  {key: 'toggleRound', state: '', msg: '', loading: true});
      commit('setWarningTime');
      console.log('Pendiente toggle round: '+roundId)
      axios
          .post(`${process.env.VUE_APP_SERVER}/backoffice/round/${roundId}/toggle`, {}, config)
          .then((res) => {
            commit('setStatusCodeFantasy',  {key: 'toggleRound', state: res.status, msg: res.statusText, loading: false});
          })
          .catch((error) => {
            commit('setStatusCodeFantasy',  {key: 'toggleRound', state: error.response.status, msg: error.response.statusText, loading: false});
          });
    },

    async detailRound({commit, rootState}, roundId) {
      const config = {
        headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      commit('setStatusCodeFantasy',  {key: 'detailRound', state: '', msg: '', loading: true});
      commit('setWarningTime');
      commit('detailRound',{});
      axios
          .post(`${process.env.VUE_APP_SERVER}/backoffice/round/${roundId}/details`, {}, config)
          .then((res) => {
            commit('detailRound', res.data);
            commit('setStatusCodeFantasy',  {key: 'detailRound', state: res.status, msg: res.statusText, loading: false});
          })
          .catch((error) => {
            commit('setNotificationFantasy', error);
            // commit('detailRound', {
            //   error:'0',
            //   result: {
            //     type: 'url',
            //     // type: 'url|json|image|txt',
            //     detail: {
            //       url: 'https://alistapart.com/article/integrating-animation-into-a-design-system/',
            //       json: { name: 'nameo'},
            //       // image: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAMAAAD04JH5AAAAdVBMVEVfMn3///97VpPPwdiHZZ0dqc8A3PNpP4Xr5e+vmL718vdhNX92T4+5pcZ9WZVzTI3h2Oe/rculjLbDss61oMOegq/XzN5uRYmQcKTKutSLaqAF0+0kn8gLyOUTu9xWQoguk8BEYp+WeKpMU5Q0f7JAdatsaqJxv90YAAAFGUlEQVR4nM2b6WKjIBSFUeiIRk1iEpO26d7O+z/iiBuLSzxXU+f8l/MpF7zAhXkEyTzMhAhYq0CILMwlpS2GPpCHprOtQIT5XQFkIoa8tUQCfYnpADJJb7tXSgGGqQD8MtW90oUvCRAlW8xeaZtECwFE4WDUjSsIJyDcBCDbT0S4BcAJH9/U9lYsjAPICcPulsT4iBgFCOfbK4VEADl53N9SOvIRhgEOM4LPVXDAAbLl7JUyECBa7PM3SgcGZD/Abubg69N2Nx1gt2D3awW9BH0A9/EfIOgBONzHXqlnMHQBdvfzZ6z7DToA9/r+lbq94ALc17+HwAGI7jD+bG2jUYDF55+u0jGAhefffmXDAHccgKYOQwDyzgHYKJADAJMD4I+ll4dGU59P+wGm5z82wCsMYOZIGkBOftwBeMABmOwBAPJPy/+ZAiC6AHz60zbACwWAcRcAmgIHQgABaCfEBgDKwAdCAAFo47AGiKAp4LU/BN6RNoLIAsCWIG/PfSFw3UCNhCYA9gEY++jrgS+sjfoTVAAJ9ixj312AD7SNxADAs4AHtwe+4Sa2GgCZA2q9vdiDEAyAUrwFAPd/Sn09mz1wfSM0cWkAgL+AoR9zEMIBUErWAHAIVrrqEMADoFRSA1ATwdcmBN6JDaQVAK0HWDkf0QOglCwBiD1Q6OOZMgMZSkqAGRtRP8r/h/68KAHozzPxXgSAT5gCGimAnP74WYjr1fdnJNN5ATBjLy4W4u9f3z/RWwgLAHoIbEQhP93zM7kJUQDQP+BZART+/JPcROAx8izAmF/4Xwp/vqe3IRk9BlUPXCRXismN5Iweg2fl75UA9FV1yOjPpsq/AngkN5Ix8iAISv8KgJM3NgQd4PxZLvAqAHJHCkYehZ9VVlsBcGoz9EkgrhcWNcACRyugjp4JENIHIlXSBDj6c36JJLW7LMp/n/o+/X9A09EAUP7+b/eB1ACl/6ysgKBLu8XS+P9yH+i9xsbf938VoN1xlq3/r/ZB2wPy0vpT+4DEzVt/oQFSSlMB6WcU1P7RSWiAdP9EaIr2Nzxpf6H9+ZEEQElIuPYX2p9TsuOMkJJtAsNfGP5ooYtSSElKM8NfGP6U7DinpOU7w78EEPs6K8B/CJKwMIlNfwXw9Fj7c3iRFlCWZqoHMqEBtD+eHQvK4rTogaPQAIY/nh2HhOV5avkLyx9eoeSEDYqj5X+y/HkIZmaULRpp+Ue2P/hLFIRNqtT292x/MDNLCNt0qeGvKsVsfzA7loSNSsP/aCxMqtwczApSwlbt2fHXAHVuhvRBs1WL9EHs+HuOP5SZNZvVyHa96++5/kAftNv1wIHF2fX3XH+gD/SBxfQjm7Pr77n+08eBcWQDhGHs+Hsd/8kxYB5aTT+22ygCs0yT7G8d2yG/xNjyLwAeBeH7OweX0MmlXYTCH58o7+8e3UJZgVWEYvkD87BzeI0d3xsEkeEfA/6d43vs8LIliE40/24BA5gWHBp/QfPvKeEA/8qH2l+Q/HuLWMDs9GCvDTH/3jIe9ADz4IV6aYb5DxQyoaVcn3pphvkPlnKhxWxxA4D5DxezweV8fgUA+o+U86FhsEkVAOg/WtCIlnQWBKj/jZJOtKh1k4L+t4pacYKZ/v9hYfP6pd3rF7evX96//gWH9a94eKtfcvHWv+az/kUnb/WrXt76l9281a/7eetfeJyDsMyVzxJh3Uuvpda99ltq5YvPNcOaV79rrXr5vdGS1///Ae9IQx5GlyhZAAAAAElFTkSuQmCC",
            //       txt: 'txt'
            //     }
            //   },
            //   description: 'el texto'
            // });
            commit('setStatusCodeFantasy',  {key: 'detailRound', state: error.response.status, msg: error.response.statusText, loading: false});
          });
    },

    async getTransactions({commit, rootState}, roundId) {
      const config = {
          headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      commit('setStatusCodeFantasy',  {key: 'getTransactions', state: '', msg: '', loading: true});
      commit('setWarningTime');
      commit('getTransactions',[]);
      axios
          .get(`${process.env.VUE_APP_SERVER}/backoffice/round/${roundId}/txs`, config)
          .then((res) => {
            commit('getTransactions', res.data);
            commit('setStatusCodeFantasy',  {key: 'getTransactions', state: res.status, msg: res.statusText, loading: false});
          })
          .catch((error) => {
            commit('setNotificationFantasy', error);
            commit('setStatusCodeFantasy',  {key: 'getTransactions', state: error.response.status, msg: error.response.statusText, loading: false});
          });
    },

    async getLobbies({ commit, rootState }){
      const config = {
        headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      commit('setStatusCodeFantasy',  {key: 'getLobbies', state: '', msg: '', loading: true});
      commit('setWarningTime');
      axios
          .get(`${process.env.VUE_APP_SERVER}/backoffice/casino/lobby/list`, config)
          .then((res) => {
            commit('getLobbies', res.data);
            commit('setStatusCodeFantasy',  {key: 'getLobbies', state: res.status, msg: res.statusText, loading: false});
          })
          .catch((error) => {
            console.log(error);
            commit('setStatusCodeFantasy',  {key: 'getLobbies', state: error.response.status, msg: error.response.statusText, loading: false});
          });
    },

    async createLobbies({ commit, rootState }, lobbiesData) {
      const config = {
        headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      commit('setStatusCodeFantasy',  {key: 'createLobbies', state:'', msg:'', loading: true});
      commit('setWarningTime');
      axios
          .post(`${process.env.VUE_APP_SERVER}/backoffice/casino/lobby/create`,lobbiesData.data, config)
          .then((res) => {
            commit('setStatusCodeFantasy', {key: 'createLobbies', state: res.status, msg:res.statusText, loading: false});
            commit('setNotificationFantasy', 'Succesfully created Lobby');
          })
          .catch((error) => {
            console.log(error);
            commit('setStatusCodeFantasy', {key: 'createLobbies', state: error.response.status, msg: error.response.statusText, loading: false});
          });
    },

    async editLobbies({commit,rootState}, lobbiesData) {
      const config = {
          headers: {Authorization: `bearer ${rootState.login.token}`},
      };
      commit('setStatusCodeFantasy',  {key: 'editLobbies', state:'', msg:'', loading: true});
      commit('setWarningTime');
      axios
          .post(`${process.env.VUE_APP_SERVER}/backoffice/casino/lobby/${lobbiesData._id}/edit`,lobbiesData.data, config)
          .then((res) => {
            commit('setStatusCodeFantasy',  {key: 'editLobbies', state: res.status, msg:res.statusText, loading: false});
            commit('setNotificationFantasy', 'Succesfully edited Lobbies');
          })
          .catch((error) => {
            commit('setStatusCodeFantasy',  {key: 'editLobbies', state: error.response.status, msg: error.response.statusText, loading: false});
            commit('setNotificationFantasy', `Lobby can't be edited by ${error.response.statusText}`);
            console.log(error);
          });
    },
  }
};
